export const reducers = {
  resetTradeState: (state) => {
    state.isOrderFilled = false;
    state.isOrderFillLoading = false;
    state.isOrderFillFailed = false;
    state.orderFillData = {};
  },
};
